import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.75 7a.75.75 0 0 0 0 1.5h9.249a.75.75 0 0 0 0-1.5zm1 4.244A1.75 1.75 0 0 0 2 12.994v2.244c0 .967.784 1.75 1.75 1.75h16.497a1.75 1.75 0 0 0 1.75-1.75v-2.244a1.75 1.75 0 0 0-1.75-1.75zm-.25 1.75a.25.25 0 0 1 .25-.25h16.497a.25.25 0 0 1 .25.25v2.244a.25.25 0 0 1-.25.25H3.75a.25.25 0 0 1-.25-.25z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }